import React, {Component} from 'react';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  FormGroup,
  Label,
  Input,
  Table
} from 'reactstrap';
import $ from 'jquery';
import ManagePage from '../../views/ManagePage/';
import ManageStaffPage from '../../views/ManageStaffPage/';

class AddGroup extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			groupname : '',
			description : '',
			_message : '',
			alertClass :'',
			posts : [],
			isadd : 1,
			_redirect : false,
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.updateClick = this.updateClick.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	onClick(e){
		
		document.getElementById("stcatform").reset();
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}

	onUpdate(e){

		e.preventDefault();
		
			$("#showLoader").show();	
			PostData('group/editgroup',this.state).then((result) => {
				$("#showLoader").hide();	
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Group Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("stcatform").reset();
					this.getdata();
				}
				else{
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
	}
	
	onSubmit(e){
		e.preventDefault();
		
			$("#showLoader").show();	
			PostData('group/addgroup',this.state).then((result) => {
				$("#showLoader").hide();	
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Group Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("stcatform").reset();
					this.getdata();
				}
				else{
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
	}
	
	updateClick(dd){

		this.setState({isadd : 0});
		this.state.id = dd;
		var index = this.state.posts.findIndex(function(obj){
		return (obj.id == dd); }); 
		this.state.groupname = this.state.posts[index].groupname;
		this.state.description = this.state.posts[index].description;
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		if (window.confirm("Do you want to Delete?")) { 
		$("#showLoader").show();	
			PostData('student/deletecategory',this.state).then((result) => {
				$("#showLoader").hide();	
				let responseJson = result;
				if(responseJson.status == '1'){
					this.setState({
						_message:'Student Category Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Student Category',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}

	onAddClick(e){
		this.setState({isadd : 1});
		document.getElementById("stcatform").reset();
	}
	
	componentDidMount() {
		 
		this.getdata();
	}
	
	getdata(){
		$("#showLoader").show();	
		GetData('group/getgroup').then((result) => {
			$("#showLoader").hide();	
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
  render() {
	
    return (
		<div>
		{sessionStorage.getItem('userrole') == 'staff' ?
			<ManageStaffPage /> : <ManagePage /> }
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				{this.state.isadd == 1 ?
				  <Col md="5">
					<form action="" method="post" role="form" id="stcatform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Card id="add">
							<CardHeader>
								<strong>Add Group</strong>
							</CardHeader>
							<CardBody>
								<Row>
									<Col md="12">
									<FormGroup>
										<Label htmlFor="name">Group Name <span className="text-danger">*</span></Label>
										<Input type="text" name="groupname" required onChange={this.onChange} />
									</FormGroup>
									</Col>
									<Col md="12">
										<FormGroup>
										<Label htmlFor="name">Description </Label>
										<Input type="text" name="description" required onChange={this.onChange} />
										</FormGroup>
									</Col>
								</Row>
							</CardBody>
							<CardFooter>
								<span style={{float : 'right'}}>
									<Button type="submit" size="sm" color="success" ><i className="fa fa-dot-circle-o"></i> Save</Button>
									<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
								</span>
							</CardFooter>
						</Card> 
					 </form>
					</Col> :
					<Col md="5">
					<form action="" method="post" role="form" id="stcatform" encType="multipart/form-data" onSubmit={this.onUpdate} >
					<Card id="edit">
					  <CardHeader>
							<strong>Edit Group</strong>
							<Button type="reset" size="sm" color="info" onClick={this.onAddClick.bind(this)} style={{float : 'right'}}><i className="fa fa-plus"></i> Add</Button>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Group Name <span className="text-danger">*</span></Label>
								  <Input type="text" name="groupname" required onChange={this.onChange} value={this.state.groupname} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Description </Label>
								  <Input type="text" name="description" required onChange={this.onChange} value={this.state.description} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="success" style={{float : 'right'}}><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					</Card> 
					</form>
				  </Col>}
				  <Col md="7">
				   <Card>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Group Name</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
						  {this.state.posts.map((item,index) =>
							<tr key = {item}>
								<td>{index+1}</td>
								<td>{item.groupname}</td>
								<td>
								<button className="btn btn-primary btn-sm" onClick={() => this.updateClick(item.id)} ><i className="fa fa-edit"></i></button>&nbsp;&nbsp;&nbsp;
								{/*<button className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>*/}
								</td>
							</tr>
						  )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default AddGroup;


// WEBPACK FOOTER //
// ./src/group/AddGroup/AddGroup.js